import { jsx as _jsx } from "react/jsx-runtime";
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import styled from 'styled-components';
export function ScrollableContainer(props) {
    return _jsx(ScrollableContainerRoot, { ...props, defer: true });
}
const ScrollableContainerRoot = styled(OverlayScrollbarsComponent) `
    height: calc(100% + 0px);
`;
